import { motion } from 'framer-motion';

export function EstimateSection() {
  return (
    <section className="relative py-20 sm:py-24 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/2512e58117118f1ccfd72f5bf167a12d.jpg"
          alt="제주 풍경"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/60 to-black/70"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1400px] mx-auto px-6 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center"
        >
          <div className="inline-flex items-center gap-3 bg-white/10 backdrop-blur-md px-6 py-3 rounded-full mb-8 border border-white/20">
            <i className="ri-file-list-3-line text-white text-xl"></i>
            <span className="text-white text-lg font-medium">단체여행 견적문의</span>
          </div>

          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            단체 여행 견적 문의
          </h2>

          <p className="text-xl sm:text-2xl text-white/90 mb-4 leading-relaxed max-w-3xl mx-auto">
            원하시는 내용을 자유롭게 적어주세요
          </p>
          <p className="text-lg sm:text-xl text-white/80 mb-10 max-w-2xl mx-auto">
            담당자 확인 후 착한 견적으로 답변드리겠습니다
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href="tel:010-5685-7818"
              className="inline-flex items-center gap-3 bg-white text-[#0E7FC0] px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-100 transition-all hover:scale-105 shadow-2xl whitespace-nowrap"
            >
              <i className="ri-phone-line text-2xl"></i>
              전화 상담하기
            </a>
            <button
              onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
              className="inline-flex items-center gap-3 bg-[#FF8E53] text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-[#ff7a3d] transition-all hover:scale-105 shadow-2xl whitespace-nowrap"
            >
              <i className="ri-message-3-line text-2xl"></i>
              실시간 상담
            </button>
          </div>

          {/* Features */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-16 max-w-4xl mx-auto">
            {[
              { icon: 'ri-team-line', title: '단체 여행', desc: '10명 이상 단체 여행 전문' },
              { icon: 'ri-price-tag-3-line', title: '합리적 가격', desc: '투명하고 착한 견적' },
              { icon: 'ri-customer-service-2-line', title: '맞춤 상담', desc: '1:1 전문 상담 서비스' }
            ].map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20"
              >
                <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className={`${feature.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                <p className="text-white/80">{feature.desc}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
